import * as React from "react";
import {
  Card,
  message,
  Form,
  Alert,
  Input,
  Button,
  Popconfirm,
  Select,
  List,
  Avatar
} from "antd";
import { NavLink } from "react-router-dom";

import { Fragment } from "react";

import { Redirect } from "react-router";
import { FormComponentProps } from "antd/lib/form";
import DeleteRole from "src/mutations/DeleteRole";
import ScopesQuery from "src/queries/ScopesQuery";
const FormItem = Form.Item;
const SelectOption = Select.Option;
export interface Role {
  ldapDN: string | null;
  ldapUUID: string | null;
  name: string;
  scopes: string[];
  default: boolean | null;
  users: RoleUser[] | null;
}

export interface RoleUser {
  id: string;
  name: string;
}

export interface Props extends FormComponentProps {
  admin: boolean;
  role: Role | null;
  loading?: boolean;
  error?: string;
  add?: boolean;
  onSubmit?: (data: Role) => void;
}

export interface State {
  deleted: boolean;
}

function toInitials(username: string): string {
  var split = username.split(".");
  return split.map(s => s[0].toUpperCase()).join("");
}

const cardStyle = { marginTop: 30, maxWidth: 750 };

export class RoleDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { deleted: false };
  }

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.props.form.validateFields((err, values: Role) => {
      if (!err && this.props.onSubmit) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    if (!this.props.add) {
      if (!this.props.loading && this.state.deleted) {
        return <Redirect to="/roles" />;
      }
      if (!this.props.loading && this.props.role == null) {
        message.error("Role not found");
        return <Redirect to="/" />;
      }
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <Fragment>
        <Card
          loading={this.props.loading}
          title={
            this.props.loading
              ? "Loading..."
              : this.props.role
              ? this.props.role.name
              : "New Role"
          }
          extra={<></>}
          style={cardStyle}
        >
          <>
            <Form onSubmit={this.handleSubmit}>
              {this.props.error && (
                <Alert
                  message={this.props.error}
                  type="error"
                  showIcon={true}
                />
              )}
              <FormItem label="Name">
                {getFieldDecorator("name", {
                  initialValue: this.props.role && this.props.role.name,
                  rules: [{ required: true, message: "Please input a name!" }]
                })(<Input readOnly={!this.props.add} />)}
              </FormItem>
              <ScopesQuery>
                {scopes => (
                  <FormItem label="Scopes">
                    {getFieldDecorator("scopes", {
                      initialValue: this.props.role
                        ? this.props.role.scopes
                        : []
                    })(
                      <Select
                        loading={scopes.loading}
                        mode="tags"
                        style={{ width: "100%" }}
                      >
                        {scopes.data &&
                          scopes.data.scopes &&
                          scopes.data.scopes.map(
                            s => s && <SelectOption key={s}>{s}</SelectOption>
                          )}
                      </Select>
                    )}
                  </FormItem>
                )}
              </ScopesQuery>

              <FormItem>
                <Button
                  loading={this.props.loading}
                  htmlType="submit"
                  type="danger"
                >
                  {this.props.add ? "Create" : "Update"}
                </Button>
              </FormItem>
            </Form>
          </>
        </Card>
        {this.props.role && (
          <Card
            loading={this.props.loading}
            title={"Users in Role"}
            style={cardStyle}
            bodyStyle={{ padding: 0 }}
          >
            {this.props.role.users && (
              <List
                grid={{ gutter: 0, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
                size="small"
                dataSource={this.props.role.users}
                renderItem={(user: RoleUser) => (
                  <List.Item>
                    <Card.Grid style={{ width: "100%" }}>
                      <NavLink to={`/users/${user.id}`}>
                        <Avatar style={{ marginRight: "1em" }}>
                          {toInitials(user.name)}
                        </Avatar>
                        {user.name}
                      </NavLink>
                    </Card.Grid>
                  </List.Item>
                )}
              />
            )}
          </Card>
        )}
        {!this.props.add && this.props.admin && (
          <Card
            className="danger"
            loading={this.props.loading}
            title="Admin"
            style={cardStyle}
          >
            {this.props.role && (
              <>
                <DeleteRole
                  onCompleted={() =>
                    this.setState({ deleted: true }, () =>
                      message.success(`${this.props.role!.name} deleted`)
                    )
                  }
                  onError={e =>
                    message.error(
                      e.graphQLErrors[0]
                        ? e.graphQLErrors[0].message
                        : "Unknown error"
                    )
                  }
                >
                  {delUser => (
                    <Popconfirm
                      title="Delete the role? This action is permanent!"
                      onConfirm={() =>
                        this.props.role &&
                        delUser({
                          variables: { name: this.props.role.name }
                        })
                      }
                      onCancel={() => console.log("cancel")}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger">Delete role</Button>
                    </Popconfirm>
                  )}
                </DeleteRole>
              </>
            )}
          </Card>
        )}
      </Fragment>
    );
  }
}

export default Form.create<Props>()(RoleDetails);



// WEBPACK FOOTER //
// ./src/components/RoleDetails/RoleDetails.tsx